import {
    stakeholdersPageItemRequest,
    stakeholdersPageListRequest
} from "../../../actions/stakeholder-actions"
import StakeholderListItem from "../../common/StakeholderListItem"
import buildListContainer from "../../common/build-list-container"

export default buildListContainer(
    StakeholderListItem,
    null,
    stakeholdersPageListRequest,
    stakeholdersPageItemRequest,
    "stakeholders"
)
